import { colorPalette } from '../../colorPalette';
import { ChevronRightOutlined } from '@next-common/material-ui-icons';
import { withStyles } from '@material-ui/core';
export const StyledIcon = withStyles({
    root: {
        margin: '0 4px',
        color: colorPalette.gray600,
        display: 'inline',
    },
})(ChevronRightOutlined);
